import * as handlers from './handlers';

const routes = {
    homepage:                     '/',
    single_hike:                  '/itineraires/:slug',
    book:                         '/book',
    book_service:                 '/book/:serviceSlug',
    book_service_next:            '/book/:serviceSlug/:next',
    assets:                       '/assets',
    contact:                      '/contact',
    cgv:                          '/cgv',
    account_dashboard:            '/account/dashboard',
    security_sign_out:            '/security/sign-out',
    customer_reservation:         '/account/reservation/:reference',
    customer_reservation_invoice: '/account/reservation/:reference/invoice/:invoiceId',
    optimalles_list:              '/optimalles',
    optimalles_list_by_theme:      '/optimalles/:theme',
    optimalles_list_by_theme_and_hike:  '/optimalles/:theme/:hike',
    others:                       '/*path'
};

let routesWithHandlers = {};
for (const route in routes) {
    if (!routes.hasOwnProperty(route)) {
        continue;
    }

    routesWithHandlers[route] = {
        pattern: routes[route]
    };

    const handler = 'handle_' + route;
    if (handlers.hasOwnProperty(handler) && typeof handlers[handler] === 'function') {
        routesWithHandlers[route].handler = handlers[handler];
    } else {
        routesWithHandlers[route].handler = handlers['handle_default'];
    }
}

export default routesWithHandlers;
